// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3EMz8","savePackageButton":"ClientWallet_savePackageButton__1U7jS"};